import { lazy } from 'react'

import Righe from './righe'

export default {
    path: '/ordini',
    title: 'Ordini acquisto',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:ordineId',
            title: 'Ordine acquisto: {{params.ordineId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Righe]
        }
    ]
}